// eslint-disable-next-line import/no-extraneous-dependencies
import MomentUtils from '@date-io/moment';
import FormTextField from 'src/components/Control/FormControls/FormTextField';
import { makeStyles } from '@material-ui/core/styles';
import { FORM } from 'src/constants/Form';
import { SEARCH_LOGICAL_OPERATORS } from 'src/models/AdvanceSearchModel';
import { getEntitiesAction, setFilters } from 'src/redux/actions/querybuilderActions';
import { ENTITIES } from 'src/models/QuerybuilderModel';
import { useAppDispatch } from 'src/redux/Store';
import { useCallback, useEffect, useState } from 'react';
import { getInvoiceFilter } from 'src/lib/PaymentHelper';
// eslint-disable-next-line import/no-extraneous-dependencies
import moment from 'moment-timezone-all';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { debounce } from '@material-ui/core';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';

const useStyles = makeStyles(() => ({
  row: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    width: '100%',
    gap: '8px',
    alignItems: 'center',
  },
  col2: {
    flex: 1,
    flexDirection: 'column',
    width: '50%',
    alignItems: 'center',
  },
}));

const UserInvoiceSearch = () => {
  const classes = useStyles();
  const dispatch = useAppDispatch();

  const form = FORM.payment_search;

  const start = moment().subtract(2, 'year');
  const end = moment();

  const [terms, setTerms] = useState('');

  const [startDate, setStartDate] = useState(start);

  const [endDate, setEndDate] = useState(end);

  useEffect(() => {
    setStartDate(startDate);
    setEndDate(endDate);
    setTerms('');
  }, []);

  const handleSearch = () => {
    const filters = getInvoiceFilter(
      startDate,
      endDate,
      terms,
    );
    dispatch(setFilters({
      entity: ENTITIES.invoices,
      filters: { [SEARCH_LOGICAL_OPERATORS.and]: filters },
    }));
    dispatch(getEntitiesAction(ENTITIES.invoices));
  };

  const searchInvoice = useCallback(
    debounce(async () => {
      handleSearch();
    }, 300),
    [], // will be created only once initially
  );

  const onChange = (value: any) => {
    setTerms(value);
    if (value.length > 2) {
      searchInvoice();
    }
  };

  const handleDateChange = (position: number, value: MaterialUiPickersDate | null) => {
    if (!value) { return; }

    let newStartDate;
    let newEndDate;

    if (position === 0) {
      newStartDate = value;
      newEndDate = endDate;
    } else {
      newStartDate = startDate;
      newEndDate = value;
    }
    if (newEndDate < newStartDate) {
      setStartDate(newStartDate);
      setEndDate(newStartDate);
      return;
    }

    setStartDate(newStartDate);
    setEndDate(newEndDate);

    const filters = getInvoiceFilter(
      newStartDate,
      newEndDate,
      terms,
    );
    dispatch(setFilters({
      entity: ENTITIES.invoices,
      filters: { [SEARCH_LOGICAL_OPERATORS.and]: filters },
    }));
    dispatch(getEntitiesAction(ENTITIES.invoices));
  };

  return (
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <div
        className={classes.row}>
        <FormTextField
          form={form}
          label="Invoice # or title"
          name="term"
          onChange={onChange}
          value={terms}
          margin="dense" />
      </div>
      <div
        className={classes.row}>
        <div className={classes.col2}>
          <span style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
          }}>
            <b>Start:</b>
            <DatePicker
              format="MM/DD/yyyy"
              margin="dense"
              id="date-picker-inline-start"
              value={startDate}
              onChange={(value) => handleDateChange(0, value)} />
          </span>
        </div>
        <div className={classes.col2}>
          <span style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
          }}>
            <b>End:</b>
            <DatePicker
              format="MM/DD/yyyy"
              margin="dense"
              id="date-picker-inline-end"
              value={endDate}
              onChange={(value) => handleDateChange(1, value)} />
          </span>
        </div>
      </div>
    </MuiPickersUtilsProvider>
  );
};

export default UserInvoiceSearch;
